'use client';
import { Checkbox as $e698a72e93240346$export$48513f6b9f8ce62d, CheckboxIndicator as $e698a72e93240346$export$59aad738f51d1c05, Indicator as $e698a72e93240346$export$adb584737d712b70, Root as $e698a72e93240346$export$be92b6f5f03c0fe9, createCheckboxScope as $e698a72e93240346$export$b566c4ff5488ea01 } from '../../external/@radix-ui/react-checkbox/dist/index.js';

var Checkbox = $e698a72e93240346$export$48513f6b9f8ce62d;
var CheckboxIndicator = $e698a72e93240346$export$59aad738f51d1c05;
var Indicator = $e698a72e93240346$export$adb584737d712b70;
var Root = $e698a72e93240346$export$be92b6f5f03c0fe9;
var createCheckboxScope = $e698a72e93240346$export$b566c4ff5488ea01;

export { Checkbox, CheckboxIndicator, Indicator, Root, createCheckboxScope };
